import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import moment from 'moment';
import { Link } from 'react-router-dom';

// react component for creating dynamic tables
import ReactTable from 'react-table';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Slide from '@material-ui/core/Slide';

// @material-ui/icons
import loader from 'assets/img/loader.gif';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';

import Style from 'assets/jss/material-dashboard-pro-react/views/actionsStyle';

// Forms

import avatar from 'assets/img/faces/user.png';

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

class ChatMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      assignActionModal: false,
      volUID: '',
      username: '',
    };
  }

  handleClickOpen = (modal, volUID) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
      volUID,
    });
  };

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };

  handleChange = (docID) => {
    console.log(docID);
  };

  parties(thread) {
    const parties =
      thread.parties.length > 1
        ? thread.parties.filter((uid) => uid != this.props.uid)
        : thread.parties;
    return parties.map((uid) => this.props.users.find((row) => row.uid === uid));
  }

  render() {
    const { classes, threads, filter } = this.props;
    console.log('threadssss', threads.dataRows)
    const searchButton = classes.top + ' ' + classes.searchButton;

    return (
      <div>
        {!this.props.loading ? (
          <div>
            {threads.dataRows &&
              threads.dataRows
                .map((thread) => ({
                  ...thread,
                  parties: this.parties(thread).filter(filter),
                }))
                .filter((thread) => thread.parties.length > 0)
                .map((thread) => {
                  return (
                    <div key={thread.tid}>
                      <Link to={{ pathname: `/threads/${thread.tid}` }}>
                        <Card>
                          <CardHeader>
                            <GridContainer>
                              <GridItem xs={2}>
                                {thread.parties.map((party, index) => {
                                console.log('partiessss', party)
                                 return(
                                  <img
                                  key={index}


                                  // profile URL isn't a property on party object
                                  src={party.profileURL || avatar}
                                  style={{ borderRadius: '50%', height: '35px' }}
                                  alt="..."
                                />
                                 )
                                })}
                              </GridItem>
                              <GridItem xs={10}>
                                {thread.caseName}
                                <h5>
                                  <b>{thread.name} </b>{' '}
                                  <small>
                                    on:{' '}
                                    {moment(thread.createdAt.toDate()).format(
                                      'MM-DD-YYYY'
                                    )}
                                  </small>
                                </h5>
                                <p className={classes.cardCategory}>
                                  {thread.parties
                                    .map(
                                      (party) =>
                                        `${party.firstName} ${party.lastName}`
                                    )
                                    .join(', ')}
                                </p>
                              </GridItem>
                            </GridContainer>
                          </CardHeader>
                          <CardBody></CardBody>
                        </Card>
                      </Link>
                    </div>
                  );
                })}
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#F7F4F0',
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <img
              style={{ margin: '65% 0% 0% 41%', position: 'relative', width: '20%' }}
              src={loader}
              alt="..."
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    uid: state.auth.user.uid,
    users: state.user.users.dataRows,
    threads: state.threads.threads,
    loading: false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(ChatMap);
